// Spain
export const locale = {
  lang: 'es',
  data: {
    TRANSLATOR: {
      SELECT: 'Elige tu idioma',
    },
    LOGOUT: {
      MESSAGE: 'CERRAR SESIÓN',
      CONFIRMATION: {
        MESSAGE: '¿Estás seguro de que deseas cerrar sesión?',
      },
    },
    POCKET_RA: {
      DIAGNOSIS_CODE: 'Código de Diagnóstico',
      CLASSIFICATION: 'Clasificación',
      DESCRIPTION: 'Descripción',
    },
    TABS_POCKETS_GUIDES: {
      QUALITY: 'Calidad',
      RISK_ADJUSTMENT: 'Ajuste de Riesgo'
    },    
    KPI_STARTS: {
      TOTAL: 'Total GIC Abiertos',
      TOTAL_RA: 'Total Miembros RA',
      TOTAL_MEMBERS: 'Miembros sin visitas'
    },
    DASHBOARD: {
      GAP_TOTAL: 'Total Citas <br/> (Pacientes)',
      GAP_COMPLETED: 'Total Atendidos',
      GAP_PENDING: 'Total Ausencias',
      GAP_EXECUTION: 'Rendimiento',
      RA_TOTAL: 'Total RA <br/> Recomendados',
      RA_COMPLETED: 'Total RA Completados',
      RA_PENDING: 'Total RA Perdidos',
      RA_EXECUTION: 'Rendimiento',
      SCHEDULE_TOTAL: 'Total GIC <br/> Recomendados',
      SCHEDULE_COMPLETED: 'Total GIC Confirmados',
      SCHEDULE_PENDING: 'Total GIC Perdidos',
      SCHEDULE_EXECUTION: 'Rendimiento',
      MY_PANEL: 'Mi Panel',
      MY_SCHEDULE: 'Mi Agenda',
      TODAY: 'Hoy'
    },    
    MENU: {
      MY_SCHEDULE: 'Mi Agenda',
      NEW: 'nuevo',
      ACTIONS: 'Comportamiento',
      CREATE_POST: 'Crear nueva publicación',
      PAGES: 'Páginas',
      FEATURES: 'Caracteristicas',
      APPS: 'Aplicaciones',
      DASHBOARD: 'Tablero',
      APPLICATION_GROUPS: 'Grupos de Aplicaciones',
      ADD_APPLICATION_GROUP: 'Agregar Grupo de Aplicaciones',
    },
    SIDEBAR_MENU: {
      SETTINGS: 'Configuración',
      LOGOUT: 'Cerrar Sesión'
    },
    APPLICATION:{
      ADD_APPLICATION_GROUP: 'Agregar Grupo de Aplicaciones',
    },
    PATIENT: {
      UPDATE_NO_SHOW: '¿Estás seguro de que deseas marcar al paciente como "No Asistió"?',
      PATIENT_PROFILE: 'Perfil del Paciente',
      PATIENT_VISIT: '¿Estás seguro de que deseas marcar la visita del paciente?',
      NO_RECORDS_FOUND: 'No se encontraron registros.'
  },
  REPORTS:{
    TODAY: 'HOY',
    MISSED: 'No realizado',
    COMPLETED: 'Completado',
    RANK: 'Calificación'
  },
    MY_SCHEDULE: {
    DATATABLE_HEADERS: {
      NAME: 'Nombre',
      STATUS: 'Estado',
      DATE: 'Fecha',
      TIME: 'Hora',
      GIC: 'GIC',
      RA: 'RA'
  },
  TABS: {
    ALL: "Todos",
    PENDING: "Pendiente",
    NO_SHOW: "No asistió",
    COMPLETED: "Completado"
  }
}, 
    GENERAL: {
      LANGUAGE: {
        TITLE: 'Idioma',
        ENGLISH: 'Inglés',
        SPANISH: 'Español'
      },
      CHANGE_PWD: 'Cambiar Contraseña',
      WALK_IN:'Consulta sin cita previa',
      LOGOUT: 'Cerrar Sesión',
      SIGN_IN: 'Sign In',
      UPLOAD_FILE: 'Upload File',
      EDIT_FILTER: 'Editar filtro',
      CLEAR_FILTER: 'Limpiar filtro',
      APPLY_FILTER: 'Aplicar filtro',
      APPLY: 'Aplicar',
      DELIVERED_EMAIL: 'Entregado',
      ACTION: 'Acción',
      NPI: 'NPI',
      NSI: 'TIM',
      FIRST_NAME: 'Nombre',
      LAST_NAME: 'Apellido',
      LOADING: 'Por favor, espere un momento...',
      CONTINUE: 'Continuar',
      WELCOME: 'Bienvenido',
      NAME: 'Nombre',
      DATE: 'Fecha',
      TIME: 'Tiempo',
      GIC: 'GIC',
      RA: 'RA',
      CODE: 'Código',
      STATUS: 'Estado',
      CREATED: 'Creado',
      MODIFIED: 'Modificado',
      NEW: 'Nuevo',
      CREATE: 'Crear',
      FILTER: 'Filtrar',
      EDIT: 'Editar',
      DELETE: 'Borrar',
      WARNING: 'Advertencia',
      WARNING_DELETE_RECORD: '¿Estás seguro de que quieres eliminar este registro?',
      OK: 'OK',
      YES: 'Sí',
      VALIDATION: {
        INVALID: '{{name}} no es válido',
        REQUIRED: '{{name}} es requerido',
        FIELD_INVALID: 'El campo no es válido',
        MIN_LENGTH: '{{name}} longitud mínima es {{min}}',
        AGREEMENT_REQUIRED: 'Se requiere aceptar los términos y condiciones',
        NOT_FOUND: 'El {{name}} solicitado no se encuentra',
        INVALID_LOGIN: 'El detalle de inicio de sesión es incorrecto',
        SESSION_LIMIT: 'Se ha alcanzado el límite de sesiones activas. Cierre sesión en otra ventana o dispositivo para continuar.',
        REQUIRED_FIELD: 'Campo requerido',
        MIN_LENGTH_FIELD: 'Longitud mínima del campo:',
        MAX_LENGTH_FIELD: 'Longitud máxima del campo:',
        INVALID_FIELD: 'El campo no es válido',
        EMAIL_INVALID: 'El correo electrónico no es válido',
      }
    },
    AUTH: {
      GENERAL: {
        OR: 'O',
        SUBMIT_BUTTON: 'Enviar',
        NO_ACCOUNT: 'No tienes una cuenta?',
        SIGNUP_BUTTON: 'Regístrate',
        FORGOT_BUTTON: 'Se te olvidó tu contraseña',
        BACK_BUTTON: 'Espalda',
        PRIVACY: 'Intimidad',
        LEGAL: 'Legal',
        ABOUT: 'Acerca de',
        CONTACT: 'Contacto',
        CONTINUE_GOOGLE: 'Continuar con Google',
        NEW_HERE: 'New Here?',
        PASSWORD_REQUIRED: 'La contraseña es requerida',
        PASSWORD_MINLENGTH: 'La contraseña debe tener al menos 3 caracteres',
        PASSWORD_MAXLENGTH: 'La contraseña debe tener un máximo de 30 caracteres',
      },
      LOGIN: {
        TITLE: 'Crear una cuenta',
        BUTTON: 'Registrarse',
        SIGN_IN_TO: 'Iniciar sesión en Aidia',
        USERNAME_OR_EMAIL: 'Nombre de usuario o correo electrónico',
        PASSWORD: 'Contraseña',
        USERNAME_OR_EMAIL_REQUIRED: 'Se requiere nombre de usuario o correo electrónico',
        USERNAME_OR_EMAIL_INVALID: 'El nombre de usuario o el correo electrónico no son válidos',
        USERNAME_OR_EMAIL_MINLENGTH: 'El nombre de usuario o el correo electrónico deben tener al menos 3 caracteres.',
        USERNAME_OR_EMAIL_MAXLENGTH: 'El nombre de usuario o el correo electrónico deben tener un máximo de 360 caracteres',
        FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
        LOGIN_FAILED_MESSAGE: 'Los datos de inicio de sesión son incorrectos',
        MESSAGE_PERSONAL_AUTHORIZATION: 'Este portal es solo para personal autorizado de {{name}}. Se prohíbe el uso compartido de credenciales para el acceso no autorizado.'
      },
      FORGOT: {
        TITLE: 'Contraseña olvidada?',
        DESC: 'Ingrese su correo electrónico para restablecer su contraseña',
        SUCCESS: 'Your account has been successfully reset.'
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.'
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Usuario'
      },
      VALIDATION: {
        INVALID: '{{name}} no es válido',
        REQUIRED: '{{name}} es requerido',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      }
    },
    INVITATION:{
      UPLOAD_INVITATION: 'Subir Invitaciones',
      TITLE: 'Invitaciones',
      RESEND_INVITATION: 'estás seguro de que quieres reenviar la invitación?',
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields'
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted'
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created'
        }
      }
    }
  }
};
